/* Uit Krabbelpaal.dc.html; bodies letterlijk overgenomen. */

import { APP_VERSION, CHAT_DOCK_MIN, DAY_POLL_MS, GH, GW, PB_URL, STUDIO_BALK, TASKBAR_H, TOOL_COL_W } from '../lib/config.js';
import { PALETTE_HEX } from '../lib/palette.js';
import { playHello, stopLijnMuziek, stopWormMuziek } from '../lib/sound.js';
import * as store from '../lib/store.js';

export default {
  isMine(g) { return g.accountId ? g.accountId === this.state.accountId : g.author === this.state.author; },

  componentDidMount() {
      const cv = this.canvasRef.current;
      if (cv) {
        const ctx = cv.getContext('2d');
        ctx.imageSmoothingEnabled = false;
        ctx.clearRect(0, 0, GW, GH);
      }
      const author = store.get('gp_author') || '';
      const accountId = store.get('gp_account_id') || '';
      const avatar = store.get('gp_avatar') || '';
      // Wie hier eerder was, blijft onthouden: ook na uitloggen weet de browser
      // nog als wie je de laatste keer was ingelogd.
      const lastId = store.get('gp_last_id') || accountId;
      const seenAt = store.get('gp_chat_seen_at') || '';
      const featuresSeen = store.get('gp_features_seen') || '';
      const spelStil = store.get('gp_spel_stil') === '1';
      const likesSeen = parseInt(store.get('gp_likes_seen') || '-1', 10);
      let likedIds = [];
      try { likedIds = JSON.parse(store.get('gp_liked_ids') || '[]'); } catch (e) {}
      this.likesInit = likesSeen < 0;
      // Elke start hetzelfde beeld: het welkomstscherm, en daarachter de paal.
      //
      // Hier stonden drie vensters die zichzelf opendeden: het welkom (alleen de
      // eerste keer), het nieuwsvenster ("nieuw in v2.8") en het thema van de dag.
      // Drie kaarten over elkaar bij binnenkomst, en welke je kreeg hing af van wat
      // er in je browser stond. Nu is er één, en die is voor iedereen gelijk.
      //
      // Het thema van vandaag staat gewoon boven het doek; klik erop en je krijgt
      // het venster alsnog. Zie openTheme in logic/themes-mod.js.
      this.setState({ welcome: true });
      if (store.get('gp_theme_hide_' + this.themeDayKey())) this.setState({ themeHidden: true });
      this.fetchThemes();
      // Projectmap: welk plekje stond er het laatst op de paal?
      let sl = 0;
      try { sl = Math.max(0, Math.min(1, parseInt(store.get('gp_slot') || '0', 10) || 0)); } catch (err) {}
      this.setState({ slot: sl }, this.readSlots);
      if (!store.get('gp_notif_seen_' + APP_VERSION)) this.setState({ notifUnseen: true });
      this.setState({ pbUrl: PB_URL, author, accountId, avatar, lastId, seenAt, featuresSeen, spelStil, likesSeen: Math.max(0, likesSeen), connected: true, likedIds }, () => {
        if (accountId) { this.tickActiveTime(true); this.beat(); this.fetchProjects(); }
        this.fetchChat();
        this.fetchAccounts();
        this.fetchDms();
        this.fetchDuo();
        this.fetchRequests();
        // Eén vraag bij het opstarten, zodat het bolletje bij Arcadehal meteen klopt
        // als er een beurt op je ligt te wachten. Daarna houdt de live-lijn het bij.
        this.ketHaal();
        this.fetchPoll();
        this.fetchComments();
        this.fetchFeatures(true);
        this.fetchGuestbook();
        this.fetchDailyPick(true);
        this.dayFetchedAt = Date.now();
        this.refreshGallery(true);
        // Wie nog niemand is krijgt hier geen venster meer voor zijn neus. Achter
        // het welkomstscherm ligt de paal, en die mag je gewoon bekijken. Inloggen
        // doe je zelf, met de knop linksonder; zie toggleStart in logic/desktop.js.
      });
      try {
        if (!store.get('gp_buzz_reset_v2')) {
          store.remove('gp_buzz_at');
          store.set('gp_buzz_reset_v2', '1');
        }
      } catch (e) {}
      window.addEventListener('keydown', this.handleKey);
      window.addEventListener('keyup', this.handleKeyUp);
      window.addEventListener('paste', this.onPasteImage);
      this.lastAct = Date.now();
      this.accTick = 0;
      window.addEventListener('pointerdown', this.noteAct, true);
      window.addEventListener('keydown', this.noteAct, true);
      window.addEventListener('resize', this.computeCanvasSize);
      this.presenceTimer = setInterval(async () => {
        if (document.hidden) return;
        await this.beat();
        if (this.pollSkip()) return;
        this.accTick = (this.accTick || 0) + 1;
        // Elke achtste ronde de volledige lijst (twee minuten), daartussen alleen
        // wie er online is.
        if (this.accTick % 8 === 0) this.fetchAccounts(); else this.fetchPresence();
        this.fetchDms();
        // fetchDuo staat hier bewust niet meer bij: de duoIdleTimer hieronder
        // doet het elke 8 seconden zolang je niet samen krabbelt, en zodra je dat
        // wel doet neemt startDuoPoll het over op 3 seconden. Beide zijn sneller
        // dan deze hartslag, dus dit was puur dubbel werk.
        if (this.state.gbOpen) this.fetchGuestbook();
      }, 15000);
      // Fijnmazige tijdteller: los van de hartslag, zodat korte bezoekjes ook meetellen.
      this.timeTimer = setInterval(() => { if (document.hidden || !this.state.accountId) return; this.tickActiveTime(); }, 5000);
      // Verzoekjes, poll en reacties: los gehouden van de hartslag. Deze drie
      // veranderen tijdens een sessie, dus die blijven op vijftien seconden.
      this.slowTick = 0;
      this.slowTimer = setInterval(() => {
        if (document.hidden || this.pollSkip()) return;
        // Staat de lijn open, dan komt nieuws vanzelf binnen en is dit nog maar een
        // vangnet: eens per minuut in plaats van elke vijftien seconden.
        if (this.liveSkip(this.slowTick++, 4)) return;
        this.fetchRequests(); this.fetchPoll(); this.fetchComments();
        // De beestjes horen hier ook bij: wie wie te eten gaf staat als melding bij
        // de bel, en dat hoort binnen te komen zonder dat je het spel opendoet. Eén
        // klein verzoek per minuut, met dezelfde rem erop als de drie hierboven.
        this.tamHaalRijen();
        // Staat de Krabbelgotchi open, dan ook zijn eigen regel ophalen en samenvoegen:
        // zo zie je een hap van een collega binnen een minuut in plaats van pas als je
        // het venster opnieuw opent. Alleen lezen, tenzij deze browser iets weet dat
        // de server nog niet heeft; zie tamHaal.
        if (this.state.beestOpen) this.tamHaal();
      }, 15000);
      // Ideeën, de krabbel van de dag en het thema van vandaag: zie fetchDayData.
      // De tik staat op een minuut, niet op vijf: fetchDayData kijkt zelf of het
      // oud genoeg is. Een timer die een fractie te vroeg afgaat zou anders zijn
      // eigen verjaringscheck missen en er nog vijf minuten bij doen.
      this.dayTimer = setInterval(() => { if (document.hidden) return; this.fetchDayData(); }, 60000);
      document.addEventListener('visibilitychange', this.onVisible);
      window.addEventListener('beforeunload', this.flushWip);
      window.addEventListener('pagehide', this.flushWip);
      this.tickTimer = setInterval(() => this.setState({ nowTick: Date.now() }), 15000);
      // Uitnodigingen om samen te krabbelen mogen niet 45 seconden blijven hangen.
      this.duoIdleTick = 0;
      this.duoIdleTimer = setInterval(() => {
        if (document.hidden || this.state.duo || this.pollSkip()) return;
        if (this.liveSkip(this.duoIdleTick++, 4)) return;
        this.fetchDuo();
      }, 8000);
      this.computeCanvasSize();
      // Nameten: bij het opstarten is de vensterbreedte soms nog niet definitief,
      // waardoor mobiel/desktop verkeerd gekozen werd.
      setTimeout(this.computeCanvasSize, 250);
      setTimeout(this.computeCanvasSize, 900);
      this.startChatPoll();
      // De open lijn met de server. Lukt dat niet, dan blijven de timers hierboven
      // op volle snelheid draaien en werkt alles precies zoals het werkte.
      this.startLive();
      this.tickClock();
      this.restoreWip();
      if (this.paalInBeeld()) this.startGalleryPoll();
      // Adressen: het scherm in de #hash openen, zodat een gedeelde link klopt.
      window.addEventListener('hashchange', this.onHashChange);
      // Ook zonder account: een gedeelde link naar een krabbel of een profiel hoort
      // te werken voor wie hem krijgt. De voorwaarde op `author` stond hier omdat
      // de hal zichzelf bij binnenkomst opendeed en die link er dan onder verdween;
      // die hal doet dat niet meer.
      // Behalve `#paal`: dat schrijft de app zelf in de balk zodra je binnen bent, en
      // die route wist het welkomstscherm. Na F5 was dat dan weg, terwijl een gewone
      // start er altijd mee begint. Op de paal sta je bij het opstarten toch al.
      const route = window.location.hash.replace(/^#\/?/, '').toLowerCase();
      if (route && route !== 'paal') this.applyRoute(window.location.hash);
    },

  /**
   * Ideeën, de krabbel van de dag en het thema van vandaag. Die veranderen hooguit
   * een paar keer per dag, dus ze hoeven niet vier keer per minuut opgehaald te
   * worden zoals eerst.
   *
   * De tijdstempel is er tegen het omgekeerde: onVisible en catchUp roepen dit ook
   * aan, en wie veel tussen tabbladen springt zou anders een regen aan verzoeken
   * veroorzaken. Alleen ophalen als het er echt oud is.
   */
  fetchDayData(force) {
      if (!force && Date.now() - (this.dayFetchedAt || 0) < DAY_POLL_MS) return;
      this.dayFetchedAt = Date.now();
      this.fetchFeatures(true);
      this.fetchDailyPick(true);
      this.fetchThemes();
    },

  /**
   * Hoe groot het doek wordt.
   *
   * Op de telefoon vult het tekenscherm het beeld, dus daar rekent hij met het hele
   * venster. Op een computer rekent hij met de maat van het programmaatje, en die
   * vraagt hij op aan studioBreed en studioHoog (logic/navigation.js): het hele
   * scherm boven de taakbalk.
   *
   * Aan het venster trekken kan niet, en dat is met opzet: dan zouden je pixels van
   * grootte veranderen terwijl je tekent.
   */
  computeCanvasSize() {
      const isMobile = window.innerWidth <= 760;
      const vensterW = this.studioBreed();
      const vensterH = this.studioHoog();
      const sideW = isMobile ? 24 : TOOL_COL_W + 152;
      const availW = vensterW - sideW - 72;
      // De strook onder het canvas hangt er los onder, dus die kost geen ruimte:
      // het thema wegklikken laat het canvas staan waar het staat. Zetten de
      // beeldknoppen zich eronder, dan schaalt het canvas wél een maatje kleiner.
      /**
       * Hoeveel ruimte de strook onder het doek vraagt.
       *
       * Het thema alleen is 43 hoog en hangt 34 boven de onderrand: 77. Staat er een
       * verzoekje bij, dan komt daar zijn blok van 46 en een gat van 8 bij. Die tweede
       * rekende hij niet mee, en dan lag de strook met een verzoekje 46 pixels over de
       * beeldenrij heen. Nagemeten. Met een verzoekje wordt het doek dus een vakje
       * kleiner; dat is een andere stand (je werkt aan een verzoekje), en takeRequest en
       * clearActiveRequest rekenen hem opnieuw uit.
       */
      const stripH = this.state.duo ? 0
        : (isMobile ? 80 : 77 + (this.state.activeRequest ? 46 + 8 : 0));
      /**
       * Wat er van de vensterhoogte af gaat voordat het doek begint.
       *
       * Op een computer, nagemeten in het venster zelf en niet nagerekend uit de
       * stijlen (zie sectie 17 van CLAUDE.md): de titelbalk met de randen van het
       * kader, de lucht boven het doek, het gat en de beeldenrij eronder, de rand van
       * het doek zelf, en een tikje marge.
       *
       * Hier stond voor allebei één getal van 224, en op een computer klopte dat niet
       * meer: het doek werd 384 waar er 448 in paste en er bleef tweeëntachtig pixels
       * leeg onderin het venster staan. Het doek schaalt per vakje van 32, dus zulke
       * reserve kost meteen twee vakjes.
       */
      // De beeldenrij is `frameSide()` hoog, en die is zo gekozen dat de rij even breed
      // is als het doek: tot 58. Hier stond 48, van toen de vakjes hoogstens 52 waren.
      const boven = isMobile ? TASKBAR_H + 224 : STUDIO_BALK + 8 + 64 + 24 + 58 + 8 + 12;
      const availH = vensterH - boven - stripH;
      const cell = Math.max(6, Math.floor(Math.min(availW / GW, availH / GH)));
      const px = cell * GW;
      const pxH = cell * GH;
      const patch = {};
      if (px !== this.state.canvasPx) patch.canvasPx = px;
      if (pxH !== this.state.canvasPxH) patch.canvasPxH = pxH;
      if (isMobile !== this.state.isMobile) patch.isMobile = isMobile;
      const wide = window.innerWidth >= 860;
      if (wide !== this.state.accTwoCols) patch.accTwoCols = wide;
      const roomy = window.innerWidth >= 1120;
      if (roomy !== this.state.roomyHeader) patch.roomyHeader = roomy;
      const tight = window.innerWidth < 1020;
      if (tight !== this.state.tightHeader) patch.tightHeader = tight;
      // Pas vanaf CHAT_DOCK_MIN is er naast de zijbalk (292, ZIJBALK_TOT in
      // logic/board.js) en de paal nog plek voor een vaste chatkolom; daaronder klapt
      // hij terug naar de knop. Hier stond 1400 en 276, en de code doet 960 en 292.
      const wideChat = window.innerWidth >= CHAT_DOCK_MIN;
      if (wideChat !== this.state.wideChat) patch.wideChat = wideChat;
      const narrow = window.innerWidth < 940;
      if (narrow !== this.state.narrowHeader) patch.narrowHeader = narrow;
      const shortH = window.innerHeight < 760;
      if (shortH !== this.state.shortH) patch.shortH = shortH;
      if (window.innerHeight !== this.state.winH) patch.winH = window.innerHeight;
      // Ook de breedte, zodat een venster dat je verder naar rechts had gezet bij een
      // smaller beeld meteen terugschuift; zie vensterStaStyle in logic/venster.js.
      if (window.innerWidth !== this.state.winW) patch.winW = window.innerWidth;
      // Van breed naar smal: op de telefoon heeft alleen de Krabbelgotchi en de
      // Krabbellijn een knop om terug te komen. Wat verder weggeklapt was, komt dan
      // gewoon weer in beeld in plaats van onbereikbaar te blijven.
      if (isMobile && !this.state.isMobile) {
        const min = this.state.vensterMin || {};
        patch.vensterMin = { beest: !!min.beest, ket: !!min.ket };
      }
      // Op een smal scherm bestaat het tekenscherm niet. Punt.
      //
      // Er zat een uitzondering op met `keepStudio`, en die stond na één bezoek aan
      // /#tekenen de hele sessie aan: applyRoute zette die vlag en zette hem nooit
      // meer uit. Daarmee kon je het venster zo smal maken als je wilde en bleef het
      // doek staan. Die vlag is helemaal weg.
      //
      // Het is ook geen `patch.isMobile` meer. Daarmee gold de regel alleen op het
      // moment dat het scherm van breed naar smal ging, en niet als je al smal was.
      // Wie er dan tóch in belandde bleef er zitten.
      //
      // De plekken die je naar het tekenscherm sturen weigeren nu zelf op mobiel en
      // zeggen waarom; zie applyRoute, takeRequest en logic/duo.js. Deze regel is
      // het net eronder, niet de eerste verdedigingslinie.
      // Op een smal scherm kun je niet tekenen; klap het weg in plaats van het te
      // sluiten, dan blijft je werk staan en kom je er op een breder scherm weer bij.
      if (isMobile && this.tekentNu()) patch.studioMin = true;
      if (Object.keys(patch).length) {
        this.setState(patch, () => {
          if (patch.studioMin) {
            this.stopGalleryPoll();
            if (this.state.connected && !this.state.galleryItems.length) this.refreshGallery();
            this.startGalleryPoll();
          }
        });
      }
    },

  componentDidUpdate(prevProps, prevState) {
      if (prevState && prevState.duo !== this.state.duo) this.computeCanvasSize();
      // De maat van het aanwijskadertje hangt af van de penseelbreedte en van het
      // gereedschap. Die veranderen via een gewone hertekening, dus hier bijwerken.
      this.paintHover();
      this.updateTitle();
      this.syncHash();
      // Eén keer per bezoek een kort deuntje als je binnenkomt.
      if (this.state.dialog === 'account' && !this.hallGreeted) { this.hallGreeted = true; playHello(); }
      if (this.state.dialog !== 'account') this.hallGreeted = false;
      // Op de telefoon mag de paal eronder niet meescrollen zolang chat, nieuws,
      // account of postvakje open staat: bevries de galerijscroller en houd zijn
      // positie vast, zodat je precies terugkomt waar je was.
      // Alleen vergrendelen als de paal ook echt in beeld is.
      const lock = this.state.isMobile && !this.tekentNu()
        && (this.state.chatOpen || this.state.notifOpen || this.state.startOpen
          || this.state.welcome || !!this.state.dialog);
      document.body.style.overflow = lock ? 'hidden' : '';
      document.body.style.overscrollBehavior = lock ? 'none' : '';
      document.documentElement.style.overscrollBehavior = lock ? 'none' : '';
      const gs = this.galleryScrollRef.current;
      if (lock) {
        if (gs) {
          if (this.lockedScrollTop === null || this.lockedScrollTop === undefined) this.lockedScrollTop = gs.scrollTop;
          gs.style.overflowY = 'hidden';
          gs.style.touchAction = 'none';
          if (gs.scrollTop !== this.lockedScrollTop) gs.scrollTop = this.lockedScrollTop;
        }
      } else {
        // Niets open? Dan de paal altijd vrijgeven — ook als de scroller
        // tussendoor van plek wisselde, anders blijft hij soms vastzitten.
        if (gs) {
          const back = this.lockedScrollTop;
          // Terugzetten op de eigen waarden — leegmaken wist de scroll uit de stijl.
          gs.style.overflowY = 'auto';
          gs.style.touchAction = 'pan-y';
          if (back !== null && back !== undefined) gs.scrollTop = back;
        }
        this.lockedScrollTop = null;
      }
      if (this.needsRestore && this.canvasRef.current) {
        this.needsRestore = false;
        const ctx = this.getCtx();
        ctx.imageSmoothingEnabled = false;
        if (this.savedImage) ctx.putImageData(this.savedImage, 0, 0);
      }
    },

  updateTitle() {
      const unread = this.chatVisible() ? 0 : this.unreadFromOthers();
      const myLikes = this.state.galleryItems.reduce((s, g) => (this.isMine(g) ? s + g.likesCount : s), 0);
      const newLikes = this.state.author ? Math.max(0, myLikes - this.state.likesSeen) : 0;
      const n = unread + newLikes;
      const t = n > 0 ? 'Krabbelpaal XP (' + n + ')' : 'Krabbelpaal XP';
      if (document.title !== t) document.title = t;
    },

  onVisible() {
      // Tabblad naar de achtergrond: eerst je krabbel veilig wegzetten.
      if (document.hidden) { this.flushWip(); return; }
      this.fetchChat();
      this.beat();
      this.fetchAccounts();
      this.fetchDms();
      this.fetchDuo();
      this.fetchRequests();
      this.fetchPoll();
      this.fetchDayData();
      if (!this.tekentNu()) this.refreshGallery(true);
    },

  componentWillUnmount() {
      clearTimeout(this.hoverTipTimer);
      window.removeEventListener('hashchange', this.onHashChange);
      window.removeEventListener('pointerdown', this.noteAct, true);
      window.removeEventListener('keydown', this.noteAct, true);
      window.removeEventListener('beforeunload', this.flushWip);
      window.removeEventListener('pagehide', this.flushWip);
      this.flushWip();
      document.removeEventListener('visibilitychange', this.onVisible);
      this.stopDuoPoll();
      clearTimeout(this.keyFlashT);
      clearInterval(this.duoIdleTimer);
      clearTimeout(this.pasteFallbackTimer);
      clearTimeout(this.duoSendTimer);
      clearTimeout(this.wipTimer);
      clearTimeout(this.extraCloudTimer);
      window.removeEventListener('paste', this.onPasteImage);
      window.removeEventListener('mousemove', this.onMarqueeWin);
      window.removeEventListener('mouseup', this.onMarqueeUpWin);
      window.removeEventListener('mousemove', this.onSelMoveWin);
      window.removeEventListener('mouseup', this.onSelUpWin);
      this.stopChatPoll();
      this.stopGalleryPoll();
      this.stopLive();
      clearTimeout(this.klokTimer);
      clearInterval(this.presenceTimer);
      clearInterval(this.timeTimer);
      clearTimeout(this.celebrateTimer);
      clearInterval(this.slowTimer);
      clearInterval(this.dayTimer);
      clearTimeout(this.clickSwallowT);
      clearInterval(this.tickTimer);
      clearTimeout(this.confettiTimer);
      clearTimeout(this.toastTimer);
      clearTimeout(this.buzzTimer);
      clearTimeout(this.touchHeartT);
      clearTimeout(this.snakeTimer);
      clearTimeout(this.memTimer);
      clearTimeout(this.tamTimer);
      // De beurtklok van de Krabbellijn is een setInterval en liep hier door.
      if (this.ketStopTik) this.ketStopTik();
      stopWormMuziek();
      stopLijnMuziek();
      // De chat had zijn eigen sleepcode met luisteraars op `window`, en die moesten
      // hier los worden opgeruimd. De vensterlaag gebruikt `setPointerCapture` en
      // hangt niets aan `window`, dus er is niets meer af te melden.
      this.vensterSleepUit();
      cancelAnimationFrame(this.playRaf);
      window.removeEventListener('keydown', this.handleKey);
      window.removeEventListener('keyup', this.handleKeyUp);
      window.removeEventListener('resize', this.computeCanvasSize);
    },

  // Spatie ingedrukt houden tijdens het slepen van een vorm: dan verplaats je
  // de vorm in plaats van hem te vergroten.
  handleKeyUp(e) {
      if (e.code === 'Space' || e.key === ' ') this.spaceHeld = false;
      if (e.key === 'Shift') this.onShift(false);
    },

  /**
   * Sluit de bovenste laag die openstaat, van binnen naar buiten. Levert false als
   * er niets te sluiten viel, zodat Escape daarna nog zijn eigen werk in het
   * tekenscherm kan doen: een pennenlijn afbreken, een selectie loslaten.
   *
   * Drie dingen staan er bewust niet bij. De uitnodiging om samen te krabbelen is
   * een vraag van iemand anders, en die per ongeluk wegtikken is vervelender dan
   * hem laten staan. Het postvakje en de afgevinkte ideeën verdwijnen pas als je
   * ze wegklikt, want dat wegklikken is meteen "gezien"; dat wil je niet per
   * ongeluk met Escape doen.
   */
  closeTopmost() {
      /**
       * Van boven naar beneden, in de volgorde waarin het op het scherm ligt.
       *
       * Eerst wat over alles heen ligt (het lijstje met hartjesgevers, de pincode, de
       * schermvullende lagen), dan het startmenu op de hoogte van de taakbalk, en pas
       * dan de vensters, in hun eigen stapelorde. Hier kwamen de vensters vóór de
       * schermvullende lagen en het startmenu, en dan sloot Escape het venster dat
       * eronder lag terwijl je naar het menu keek.
       *
       * Het lijstje met hartjesgevers alleen als je het ziet: klapte je de krabbel weg
       * terwijl het open stond, dan sloot de eerste Escape een lijst die niemand zag.
       */
      if (this.state.likersOpen && this.vensterInfo('viewer').open) { this.hideLikers(); return true; }
      // Eerst het vlak loslaten; pas als er geen vlak ligt gaat het venster dicht.
      if (this.state.avatarEditorOpen && this.avClearSel()) return true;
      if (this.state.avatarEditorOpen) { this.cancelAvatarEditor(); return true; }
      if (this.state.pinFor) { this.closePin(); return true; }
      if (this.state.reqSentTo) { this.setState({ reqSentTo: '' }); return true; }
      if (this.state.reqTo) { this.setState({ reqTo: '', reqText: '', reqError: '' }); return true; }
      if (this.state.logoutConfirm) { this.cancelLogout(); return true; }
      if (this.state.welcome) { this.closeWelcome(); return true; }
      // Snake heeft een klok die uit moet; closeDialog alleen zou hem laten lopen.
      if (this.state.dialog === 'snake') { this.closeSnake(); return true; }
      // Memory heeft een klok die een misser dichtdoet; die moet ook uit.
      if (this.state.dialog === 'memory') { this.closeMemory(); return true; }
      if (this.state.dialog) { this.closeDialog(); return true; }
      // De bel hangt op dezelfde hoogte als het startmenu. "Gezien" zet hij al bij
      // het openen, dus dichtdoen met Escape kost je niets.
      if (this.state.notifOpen) { this.setState({ notifOpen: false }); return true; }
      if (this.state.startOpen) { this.closeStart(); return true; }
      /**
       * En dan de vensters: het bovenste eerst, volgens de stapelorde.
       *
       * De chat en de krabbelviewer doen gewoon mee; ze stonden er los onder of boven,
       * en dan sloot Escape de krabbel onder een spelletje of het venster onder de
       * chat. Het tekenvenster niet: Escape midden in het tekenen zou je doek
       * wegklappen.
       */
      // Ligt het tekenvenster vooraan, dan is Escape van het doek: een selectie
      // loslaten. Anders sloot hij het venster dat erachter lag.
      if (this.vensterVoorop() === 'studio') return false;
      // De Krabbellijn: eerst het kader los, net als op het doek. Het kruisje van dat
      // venster breekt je beurt af, en dat hoort niet bij een Escape voor een kader.
      if (this.vensterVoorop() === 'ket' && (this.state.ketSel || this.state.ketVoor)) {
        this.setState({ ketSel: null, ketVoor: null }, this.ketTeken);
        return true;
      }
      const vensters = this.vensterLijst().filter((x) => x.open && x.naam !== 'studio');
      for (const naam of (this.state.vensterOrde || []).slice().reverse()) {
        const w = vensters.find((x) => x.naam === naam);
        if (w) { w.sluit(); return true; }
      }
      // Een venster dat open staat maar nog nooit is aangeraakt staat niet in de orde.
      if (vensters.length) { vensters[0].sluit(); return true; }
      if (this.state.themePopup) { this.closeTheme(); return true; }
      return false;
    },

  handleKey(e) {
      // Escape gaat vóór alles, ook met de cursor in een invulveld: juist daar wil
      // je kunnen ontsnappen. Vroeger sloot Escape alleen de krabbelviewer en het
      // sneltoetsenkaartje, en bleef je in de andere dertig vensters hangen.
      if (e.key === 'Escape' && this.closeTopmost()) { e.preventDefault(); return; }
      const tag = (e.target.tagName || '').toLowerCase();
      if (tag === 'input' || tag === 'textarea') return;
      // Staat Snake open, dan zijn de pijltjes en de spatie van het spel. Dit
      // moet vóór de rest: de spatie is anders de playknop van het tekenscherm.
      if (this.state.dialog === 'snake' && this.snakeKey(e)) { e.preventDefault(); return; }
      // De pijltjes schuiven het aangewezen vlak in de avatar-tekenaar op.
      if (this.state.avatarEditorOpen && /^Arrow(Left|Right|Up|Down)$/.test(e.key)) {
        const dx = e.key === 'ArrowLeft' ? -1 : e.key === 'ArrowRight' ? 1 : 0;
        const dy = e.key === 'ArrowUp' ? -1 : e.key === 'ArrowDown' ? 1 : 0;
        if (this.avNudge(dx, dy, e.shiftKey)) { e.preventDefault(); return; }
      }
      // Shift alleen is geen sneltoets, maar houdt wel een vorm recht.
      if (e.key === 'Shift') { this.onShift(true); return; }
      if (e.code === 'Space' || e.key === ' ') {
        if (this.tekentNu() && this.state.drawing && this.isShapeTool(this.state.tool)) {
          e.preventDefault();
          this.spaceHeld = true;
          return;
        }
        // Spatie is de sneltoets voor de playknop: start of stop het afspelen.
        if (this.tekentNu() && !e.repeat) {
          e.preventDefault();
          this.flashKey('play');
          this.togglePlay();
        }
        return;
      }
      // Cmd+Z hoort bij wat er vóór je staat. Staat de avatar-tekenaar open, dan is
      // dat je avatar en niet de krabbel die eronder ligt; die maakte hij eerst wel
      // ongedaan, en dat zag je niet want het venster ligt ervoor.
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'z') {
        e.preventDefault();
        if (this.state.avatarEditorOpen) { if (e.shiftKey) this.avRedoStep(); else this.avUndo(); return; }
        // Zelfde verhaal voor de beestjestekenaar: die ligt er ook overheen.
        if (this.state.dialog === 'beestje') { if (e.shiftKey) this.stapVooruit(); else this.stapTerug(); return; }
        if (e.shiftKey) { this.flashKey('redo'); this.redo(); } else { this.flashKey('undo'); this.undo(); }
        return;
      }
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'y') { e.preventDefault(); this.flashKey('redo'); this.redo(); return; }
      /**
       * Hieronder staan de tekensneltoetsen: B, E, G, L, M, de cijfers, de pijltjes.
       *
       * Die mogen alleen door als het doek vóór je ligt. Dit stond op
       * `view !== 'studio'`, en dat was veilig zolang de paal en het doek niet samen
       * konden bestaan. Met een tekenvenster dat weggeklapt open kan staan is dat niet
       * meer waar: dan verandert je penseel terwijl je naar de paal kijkt.
       */
      if (!this.tekentNu()) return;
      // Het sneltoetsenkaartje: ? opent en sluit, Esc sluit ook.
      if (e.key === '?') { e.preventDefault(); this.setState({ dialog: this.state.dialog === 'keys' ? null : 'keys' }); return; }
      if (this.state.dialog === 'keys') return;
      if (e.metaKey || e.ctrlKey) {
        const ck = e.key.toLowerCase();
        if (ck === 'a') { e.preventDefault(); if (e.shiftKey) this.clearSel(); else this.selectAll(); return; }
        if (ck === 'c') { e.preventDefault(); this.flashKey('copy'); this.copySel(); return; }
        if (ck === 'x') { e.preventDefault(); this.flashKey('copy'); this.cutSel(); return; }
        // Cmd+V houden we niet tegen: de browser stuurt zelf een plak-bericht, en
        // onPasteImage kiest daar tussen een plaatje van het klembord en het
        // eigen knipsel.
        if (ck === 'v') {
          this.flashKey('paste');
          // Blijft dat bericht uit (sommige browsers sturen er geen), dan plakken
          // we alsnog het eigen knipsel.
          clearTimeout(this.pasteFallbackTimer);
          this.pasteFallbackTimer = setTimeout(() => { if (this.clip) this.pasteClip(); }, 150);
          return;
        }
      }
      if (/^[1-8]$/.test(e.key) && !e.metaKey && !e.ctrlKey && !e.altKey) {
        const i = parseInt(e.key, 10) - 1;
        if (PALETTE_HEX[i]) { e.preventDefault(); this.pickPaletteColor(i); }
        return;
      }
      if (!e.metaKey && !e.ctrlKey && !e.altKey && (e.key === '+' || e.key === '=' || e.key === 'Add' || e.key === ']' || e.key === '}')) { e.preventDefault(); this.flashKey('plus'); this.incBrush(); return; }
      if (!e.metaKey && !e.ctrlKey && !e.altKey && (e.key === '-' || e.key === '_' || e.key === 'Subtract' || e.key === '[' || e.key === '{')) { e.preventDefault(); this.flashKey('minus'); this.decBrush(); return; }
      const k = e.key.toLowerCase();
      // Zelfde letters als Photoshop: B penseel, E gum, G emmer, L lasso. F en V
      // blijven werken voor wie ze gewend is. P en U liepen naar de pentool; die is
      // er niet meer, dus nu lopen ze door de vormen. I is van isometrisch.
      if (k === 'b') { this.flashKey('pencil'); this.selectPencil(); }
      else if (k === 'e') { this.flashKey('eraser'); this.selectEraser(); }
      else if (k === 'g' || k === 'f') { this.flashKey('fill'); this.selectFill(); }
      else if (k === 's') { this.flashKey('spray'); this.selectSpray(); }
      else if (k === 'l' || k === 'v') { this.flashKey('select'); this.selectLasso(); }
      else if (k === 'm') { this.flashKey('select'); this.selectMarquee(); }
      else if (k === 'p' || k === 'u') { this.flashKey('pen'); this.selectPen(); }
      else if (k === '/') { this.flashKey('pen'); this.setShapeTool('line'); }
      else if (k === 'r') { this.flashKey('pen'); this.setShapeTool('rect'); }
      else if (k === 'o') { this.flashKey('pen'); this.setShapeTool('circle'); }
      // I van isometrisch: de hulplijnen onder het doek, uit of aan.
      else if (k === 'i') { this.flashKey('hulp'); this.cycleHulp(); }
      else if (k === 'h') { this.flipArt(e.shiftKey); }
      else if (k === 'x') { this.swapColor(); }
      else if (this.state.sel && /^Arrow(Left|Right|Up|Down)$/.test(e.key)) {
        e.preventDefault();
        const step = e.shiftKey ? 8 : 1;
        this.nudgeSel(
          (e.key === 'ArrowLeft' ? -step : e.key === 'ArrowRight' ? step : 0),
          (e.key === 'ArrowUp' ? -step : e.key === 'ArrowDown' ? step : 0)
        );
      }
      else if (!e.repeat && /^Arrow(Left|Right)$/.test(e.key)) { e.preventDefault(); this.stepFrame(e.key === 'ArrowRight' ? 1 : -1); }
      // Backspace haalt de kleur uit de selectie weg; de selectie blijft liggen,
      // dus een kleur erna vult hetzelfde vlak weer op.
      else if (this.state.sel && (e.key === 'Delete' || e.key === 'Backspace')) { e.preventDefault(); this.eraseSel(true); }
      else if (e.key === 'Escape') { this.clearSel(); }
    }
};
